import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getUser } from 'reducers/user';

export const useGetUser = () => {
    const reduxDispatch = useDispatch();

    useEffect(() => {
        reduxDispatch(getUser());
    }, []);
};
